<form-card *transloco="let t;">
    <div class="form-card">
        <div class="h-full flex flex-col items-center">
            <div class="w-40">
                <img [src]="marketingSettings.kmonLogoPath" />
            </div>
            <p class="mt-7 text-3xl font-medium"> {{!marketingSettings.createAccount?
                t('signUp.createAccount'):marketingSettings.createAccount|uppercase}}</p>
            <p class="mt-1 text-base font-normal "
                [innerHTML]="!marketingSettings.subTitle? t('signUp.subTitle') : marketingSettings.subTitle"> </p>
            <form [formGroup]="createUserForm" class="w-full flex flex-col items-center">
                <!-- Form Control -->
                <!-- EMAIL -->
                <input class="w-full mt-6 mb-1" type="text" [placeholder]="t('shared.email')" pInputText
                    formControlName="email" />
                <small class="form-hint"
                    [ngClass]="{'form-hint-error':!createUserForm.controls['email'].valid && createUserForm.controls['email'].value.length > 0}">{{t('formHint.emailNotValid')}}</small>
                <!-- PASSWORD -->
                <div class="password-container w-full relative">
                    <input class="w-full mt-2 mb-2" [type]="!isPasswordVisible ? 'password':'text'"
                        [placeholder]="t('shared.password')" pInputText formControlName="password" />
                    <fa-icon [icon]="['fas', !isPasswordVisible ? 'eye':'eye-slash']"
                        (click)="isPasswordVisible = !isPasswordVisible"></fa-icon>
                </div>
                <password-meter [password]="password" class="w-full mb-1"></password-meter>
                <small class="form-hint"
                    [ngClass]="{'form-hint-error':!createUserForm.controls['password'].valid && createUserForm.controls['password'].value.length > 0}">{{t('formHint.password')}}</small>
                <!-- USERNAME -->
                <input class="w-full mt-2 mb-1" type="text" [placeholder]="t('shared.username')" pInputText
                    formControlName="username" />
                <small class="form-hint"
                    [ngClass]="{'form-hint-error':!createUserForm.controls['username'].valid && createUserForm.controls['username'].value.length > 0}">{{t('formHint.username')}}</small>

                <!-- OLD WALLET SELECTOR -->
                <!-- <p-selectButton [options]="walletSelector" formControlName="wallet" optionLabel="label"
                    optionValue="value" class="wallet-selector mt-6 mb-1">
                    <ng-template let-item>
                        <div class="flex flex-col sm:flex-row h-full items-center">
                            <img class="w-9 h-fit" [src]="item.src" />
                            <div class="h-full text-md text-start text-white pl-2 leading-normal">
                                <span>{{item.label}}</span>
                            </div>
                        </div>
                    </ng-template>
                </p-selectButton> -->
                <!-- WALLET SELECTOR -->
                <div class="w-full mt-2 mb-1 custom-form">
                    <div class="flex w-full mt-3 mb-3 items-center">
                        <p-inputSwitch class="" formControlName="isWalletconnect"></p-inputSwitch>
                        <div class="flex flex-col ml-3">
                            <span
                                class="font-sans font-medium text-md leading-6">{{t('signUp.walletSelectorToggle')|uppercase}}</span>
                            <small class="form-hint text-sm">{{t('formHint.walletSelectorToggle')}}</small>
                        </div>
                        <div class="flex ml-auto mr-2">
                            <img class="h-6 w-auto" src="./assets/img/Icon/Metamask.svg" alt="">
                            <img class="h-6 w-auto ml-1" src="./assets/img/Icon/Trust-Wallet.svg" alt="">
                        </div>
                    </div>
                </div>
                <!-- REFERRAL CODE -->
                <div class="w-full flex flex-col mt-2 mb-1 pr-2 custom-form">
                    <div class="flex w-full mt-3 mb-3">
                        <p-inputSwitch class="" formControlName="isReferal"></p-inputSwitch>
                        <div class="flex ml-3">
                            <span
                                class="font-sans font-medium text-md leading-6">{{t('signUp.referralCodeToggle')|uppercase}}</span>
                        </div>
                        <img class="ml-auto h-6 w-auto" src="./assets/img/Icon/icon-gift-gradient.svg" alt="">
                    </div>
                    <input *ngIf="createUserForm.get('isReferal').value" class="w-full mb-3" type="text"
                        [placeholder]="t('signUp.referralCode')" pInputText formControlName="referralCode" />
                    <small *ngIf="createUserForm.get('isReferal').value"
                        class="form-hint text-sm mb-2">{{t('formHint.referralCode')}}</small>
                </div>
            </form>
            <!-- NEED HELP -->
            <div class="ml-auto mt-2 text-k-pink text-sm underline">
                <a [href]="helpLink" target="_blank">{{t('signIn.needHelp')}}</a>
            </div>
            <!-- ACTIONS -->
            <div class="flex mt-3">
                <a class="mt-auto mb-4 pr-3" [routerLink]="'/sign-in'" [queryParams]="queryParam">
                    <!-- <k-button outline="true">
                        <fa-icon [icon]="['fas', 'chevron-left']" class="mr-1"></fa-icon>
                        {{t('shared.back')|uppercase}}</k-button> -->
                    <k-button buttonStyle="transparent" [faIcon]="['fas', 'chevron-left']" [label]="t('shared.back')"
                        *ngIf="!marketingSettings.hideBackButton">
                    </k-button>
                </a>
                <!-- <k-button [isDisabled]="!createUserForm.valid" type="submit"
                    (click)="createAccount()">{{t('shared.confirm')|uppercase}}</k-button> -->
                <k-button [isDisabled]="!createUserForm.valid" type="submit" (click)="createAccount()"
                    [label]="t('shared.create')"></k-button>
            </div>
        </div>
    </div>

</form-card>